import { ITableHeaderProps } from "venice-ui";
import { IListConfing } from "./configs";
import { t } from "../helpers/userHelper";
import { dictionary } from "../untils/dictionary";
import { fields, Scopes } from "./fields";
import { IOrgFiledsConfigs, UserContract } from "../store/interface/user";
import { maxFileSize } from "../helpers/mathHelpers";
import { projectFormExclude, sectionFormExclude } from "./serializaConfigs";
import {
  IFieldsState,
  ISelectedState,
} from "../components/Organization/SettingForms/SettingForms";
import _ from "lodash";
import { FormDataProps } from "venice-ui/dist/types/components/Form/formTypes";
import { IProject } from "../store/interface/projects";
import { IProjectDetailsObj } from "../store/interface/projectDetails";
import { ISpoolElement } from "../definitions/spools";

//ToDo create unit test for this
export const setHeaders = (
  config: IListConfing[],
  mode: string,
  spools?: ISpoolElement[]
) => {
  const headers: ITableHeaderProps[] = [];
  config.forEach((_config) => {
    const filedDefinition = fields.find((_fd) => _fd.id === _config.id);
    let isAdd = true;
    if (mode === "show") {
      if (!_config.visable) {
        isAdd = false;
      }
    } else if (mode === "export") {
      if (!_config.export) {
        isAdd = false;
      }
    }
    if (isAdd) {
      const item: ITableHeaderProps = {
        name: t(dictionary[_config.id as keyof typeof dictionary]),
        valueSource: _config.id,
      };

      if (filedDefinition!.formType === "date") {
        item.date = true;
      }
      if (filedDefinition?.formType === "fill") {
        item.valueSource = filedDefinition.id.split("ID")[0] + "Name";
      }
      headers.push(item);
    }
  });
  return headers;
};

export const getConfig = (configs: IOrgFiledsConfigs[], name: string) => {
  const config = configs.find((_item) => _item.configName === name);
  return config!.config;
};

export const getContractsStrictScope = (
  value: string,
  label: string,
  scope: any[]
) => {
  const options: any[] = [];
  scope.map((_item) => {
      options.push({ value: _item[value], label: _item[label] , disabled: _item.projects.length !== 0});
  });
  return options;
};
export const getSelectScope = (value: string, label: string, scope: any[]) => {
  const options: any[] = [];
  scope.map((_item) => {
    options.push({ value: _item[value], label: _item[label] });
  });
  return options;
};

export const getFillElementsScopes = (
  name: string,
  sourceFiled: string,
  scope: string,
  projectDetails: IProjectDetailsObj,
  projects: IProject[],
  sectionID?: string
) => {
  const options: any[] = [];
  if (scope === "projectDetails") {
    const valueField = `${name}`;
    const short = name.split("ID")[0];
    const labelField = `${short}Name`;
    projectDetails[sourceFiled].forEach((_item: any) => {
      if (sectionID) {
        if (_item.sectionID === sectionID) {
          options.push({ value: _item[valueField], label: _item[labelField] });
        }
      } else {
        options.push({ value: _item[valueField], label: _item[labelField] });
      }
    });
  }
  return options;
};

const checkFileSize = (filed: number) => {
  return (filed as number) > maxFileSize;
};

//ToDo create unit test for this
interface IFunctionsArray {
  id: string;
  fn: any;
}
export const setFormConfig = (
  configs: IOrgFiledsConfigs[],
  name: string,
  formState: Record<string, string | number | File | undefined>,
  contracts: UserContract[],
  projectDetails: IProjectDetailsObj,
  projects: IProject[],
  editMode?: boolean,
  sectionID?: string,
  functionsArray?: IFunctionsArray[],
  isStrict?: boolean
): FormDataProps[] => {
  let data: FormDataProps[] = [];
  const initConfig = getConfig(configs, name);

  const config = editMode ? getFilteredConfig(initConfig, name) : initConfig;
  config.forEach((_config) => {
    const fieldDef = fields.find((_item) => _item.id === _config.id);
    if (fieldDef) {
      const item: FormDataProps = {
        type: fieldDef.formType,
        label: t(dictionary[fieldDef.id as keyof typeof dictionary]),
        value: formState[fieldDef.id],
        name: fieldDef.id,
        autofocus: false,
      };
      if (fieldDef.formType === "select") {
        item.zIndex = 1000;
        item.position = "left";
        item.placeholder = t(dictionary.pleaseSelect);

        item.options = fieldDef.options
          ? fieldDef.options
          : (fieldDef.id === "contractName" && isStrict)
          ? getContractsStrictScope(
              fieldDef.sourceFiled as string,
              fieldDef.name,
              contracts
            )
          : getSelectScope(
              fieldDef.sourceFiled as string,
              fieldDef.name,
              contracts
            );
      }
      if (fieldDef.formType === "fill") {
        item.zIndex = 1000;
        item.position = "left";
        item.placeholder = t(dictionary.pleaseSelect);
        if (functionsArray) {
          const ifExist = functionsArray.find((_fn) => _fn.id === fieldDef.id);
          if (ifExist) {
            item.handleAddToScope = ifExist.fn;
          }
        }

        item.options = getFillElementsScopes(
          fieldDef.name,
          fieldDef.sourceFiled as string,
          fieldDef.sourceScope as string,
          projectDetails,
          projects,
          sectionID
        );
      } else if (fieldDef.type === "source") {
        if (!formState[fieldDef.id]) {
          const value = getValueForSource(
            fieldDef.name,
            formState[fieldDef.sourceFiled as string] as string,
            fieldDef.sourceScope as string,
            projectDetails,
            projects,
            contracts
          );
          formState[fieldDef.id] = value;
        }
      } else if (fieldDef.formType === "file") {
        item.subLabel = t(dictionary.maxFileSize);
        item.error = checkFileSize(formState.fileSize as number);
      } else if (fieldDef.formType === "date") {
        item.zIndex = 1100;
      }
      data.push(item);
    }
  });

  return data;
};
export const getValueForSource = (
  name: string,
  sourceFiled: string,
  scope: string,
  projectDetails: IProjectDetailsObj,
  projects: IProject[],
  contracts: UserContract[]
) => {
  let value = "";
  if (scope === "projects") {
    const searchObj = projects.find(
      (_project) => _project.projectID === sourceFiled
    );
    if (searchObj) {
      value = searchObj[name] as string;
    }
  } else if (scope === "sections") {
    const searchObj = projectDetails.sections.find(
      (_section) => _section.sectionID === sourceFiled
    );
    if (searchObj) {
      value = searchObj[name] as string;
    }
  } else if (scope === "contracts") {
    const searchObj = contracts.find(
      (_contract) => _contract.contractID === sourceFiled
    );
    if (searchObj) {
      value = (searchObj as any)[name];
    }
  }
  return value;
};

//ToDo create unit test for this
export const getFilteredConfig = (initConfig: IListConfing[], name: string) => {
  if (name === Scopes.AddSectionForm) {
    return initConfig.filter((_item) => !sectionFormExclude.includes(_item.id));
  } else if (name === Scopes.AddProjectForm) {
    return initConfig.filter((_item) => !projectFormExclude.includes(_item.id));
  } else {
    return initConfig;
  }
};

//ToDo create unit test for this
export const setObjectState = (
  configs: IOrgFiledsConfigs[],
  name: string,
  editMode?: boolean,
  dataSet?: Record<string, string | number | undefined | File | boolean>
) => {
  const initConfig = getConfig(configs, name);
  const config = editMode ? getFilteredConfig(initConfig, name) : initConfig;
  const state: Record<string, any> = {};
  config.forEach((_config) => {
    const filedDef = fields.find((_itme) => _itme.id === _config.id);
    if (filedDef) {
      if (filedDef.formType === "file") {
        state[filedDef.id as string] = undefined;
      } else if (filedDef.formType === "date") {
        state[filedDef.id as string] =
          editMode && dataSet
            ? dataSet[filedDef.id as string]
              ? dataSet[filedDef.id as string]
              : null
            : null;
      } else if (
        filedDef.formType === "text" ||
        filedDef.formType === "number"
      ) {
        state[filedDef.id as string] =
          editMode && dataSet ? dataSet[filedDef.id as string] : "";
      } else if (filedDef.formType === "select") {
        if (filedDef.sourceType && filedDef.sourceType === "field") {
          state[filedDef.id as string] =
            editMode && dataSet ? dataSet[filedDef.sourceFiled as string] : "";
        } else if (filedDef.source && filedDef.source === "options") {
          state[filedDef.id as string] = dataSet
            ? dataSet[filedDef.id as string]
            : "-";
        }
      }
    }
    if (name === Scopes.AddSectionForm) {
      state.fileSize = 0;
    }
    if (editMode && dataSet) {
      state.show = dataSet.show || true;
    }
  });

  return state;
};

//ToDo create unit test for this
export interface IRowsConfig {
  number: number;
  fields: IListConfing[];
}
export const setRowsFromFileds = (fields: IListConfing[]): IRowsConfig[] => {
  const rows: any[] = [];

  fields.forEach((field) => {
    const ifExist = rows.find((_row) => _row.number === field.group);
    if (ifExist) {
      ifExist.fields.push(field);
    } else {
      rows.push({
        number: field.group,
        fields: [field],
      });
    }
  });
  rows.sort((a: any, b: any) => a.number! - b.number!);
  rows.forEach((row) => {
    row.fields.sort((a: any, b: any) => a.groupIndex! - b.groupIndex!);
  });
  return rows;
};

//ToDo create unit test for this
export const handleMoveItem = (
  selected: ISelectedState,
  activeFields: IListConfing[]
) => {
  const {
    hoverID,
    movedItem,
    sourceList,
    targetList,
    targetGroup,
    sourceGroup,
  } = selected;
  const itemIndex = activeFields.findIndex((_item) => _item.id === hoverID);
  const sourceIndex = activeFields.findIndex((_item) => _item.id === movedItem);

  if (sourceList !== targetList) {
    if (targetList === "active" && sourceList === "unactive") {
      //add
      activeFields.forEach((_item) => {
        if (_item.itemIndex! > itemIndex) {
          _item.itemIndex = _item.itemIndex! + 1;
        }
      });
      activeFields.push({
        id: movedItem,
        visable: true,
        export: true,
        itemIndex: itemIndex + 1,
      });
    } else if (targetList === "activeGroups" && sourceList === "unactive") {
      if (targetGroup !== -1) {
        //add to existing group
        const targetElement = activeFields.find(
          (_item) => _item.id === hoverID
        );
        const groupID = targetGroup;
        const groupIndex = targetElement?.groupIndex || 0;
        const group = activeFields.filter((_item) => _item.group === groupID);
        if (hoverID === "frontBox") {
          //add at begin
          group.forEach((_item) => {
            _item.groupIndex = _item.groupIndex! + 1;
          });
          activeFields.push({
            id: movedItem,
            visable: true,
            export: true,
            groupIndex: 0,
            group: groupID,
          });
        } else {
          //add in order
          group.forEach((_item) => {
            if (_item.groupIndex! > groupIndex) {
              _item.groupIndex = _item.groupIndex! + 1;
            }
          });
          activeFields.push({
            id: movedItem,
            visable: true,
            export: true,
            groupIndex: groupIndex + 1,
            group: groupID,
          });
        }
      } else {
        //add to new group, id is "after_" ..
        if (hoverID === "topBox") {
          activeFields.forEach((_item) => {
            _item.group = _item.group! + 1;
          });
          activeFields.push({
            id: movedItem,
            visable: true,
            export: true,
            groupIndex: 0,
            group: 0,
          });
        } else {
          const groupID = parseInt(hoverID.replace("after_", ""));
          activeFields.forEach((_item) => {
            if (_item.group! > groupID) {
              _item.group = _item.group! + 1;
            }
          });
          activeFields.push({
            id: movedItem,
            visable: true,
            export: true,
            groupIndex: 0,
            group: groupID + 1,
          });
        }
      }
    } else if (targetList === "unactive" && sourceList === "active") {
      //remove
      const ifRequirer = activeFields[sourceIndex].required || false;
      if (!ifRequirer) {
        activeFields.forEach((_item) => {
          if (_item.itemIndex! >= sourceIndex) {
            _item.itemIndex = _item.itemIndex! - 1;
          }
        });
        activeFields = activeFields.filter((_item) => _item.id !== movedItem);
      } else {
        return false;
      }
    } else if (targetList === "unactive" && sourceList === "activeGroups") {
      const ifRequirer = activeFields[sourceIndex].required || false;
      if (!ifRequirer) {
        const sourceElement = activeFields.find(
          (_item) => _item.id === movedItem
        );
        const groupID = sourceGroup;
        const groupIndex = sourceElement?.groupIndex || 0;
        const group = activeFields.filter((_item) => _item.group === groupID);

        if (group.length > 1) {
          //remove item from group
          group.forEach((_item) => {
            if (_item.groupIndex! > groupIndex) {
              _item.groupIndex = _item.groupIndex! - 1;
            }
          });
        } else {
          //only this one is in the group, remove group
          activeFields.forEach((_item) => {
            if (_item.group! > groupID) {
              _item.group = _item.group! - 1;
            }
          });
        }
        activeFields = activeFields.filter((_item) => _item.id !== movedItem);
      } else {
        return false;
      }
    }
  } else {
    //change index
    if (targetList === "activeGroups") {
      //in joins group

      if (sourceGroup === targetGroup) {
        //the same group
        const sourceElement = activeFields.find(
          (_item) => _item.id === movedItem
        );
        const groupID = sourceGroup;
        const groupIndex = sourceElement?.groupIndex || 0;
        const group = activeFields.filter((_item) => _item.group === groupID);

        const targetIndex =
          hoverID === "frontBox"
            ? -1
            : group.find((_item) => _item.id === hoverID)?.groupIndex || 0;
        if (groupIndex >= targetIndex) {
          //move right
          group.forEach((_item) => {
            if (_item.id === movedItem) {
              _item.groupIndex = hoverID === "frontBox" ? 0 : targetIndex + 1;
            } else if (_item.groupIndex! > targetIndex) {
              _item.groupIndex = _item.groupIndex! + 1;
            }
          });
        } else {
          //move left
          group.forEach((_item) => {
            if (_item.id === movedItem) {
              _item.groupIndex = targetIndex;
            } else if (_item.groupIndex! <= targetIndex) {
              _item.groupIndex = _item.groupIndex! - 1;
            }
          });
        }
      } else {
        // diffrent group
        const sGroup = activeFields.filter(
          (_item) => _item.group === sourceGroup
        );
        if (targetGroup !== -1) {
          // to existing one
          const tGroup = activeFields.filter(
            (_item) => _item.group === targetGroup
          );
          const targetGroupIndex =
            hoverID === "frontBox"
              ? 0
              : tGroup.find((_item) => _item.id === hoverID)?.groupIndex || 0;
          const sourceGroupIndex =
            sGroup.find((_item) => _item.id === movedItem)?.groupIndex || 0;
          tGroup.forEach((_item) => {
            if (_item.groupIndex! >= targetGroupIndex) {
              _item.groupIndex = _item.groupIndex! + 1;
            }
          });
          if (sGroup.length > 1) {
            sGroup.forEach((_item) => {
              if (_item.id === movedItem) {
                _item.group = targetGroup;
                _item.groupIndex =
                  hoverID === "frontBox" ? 0 : targetGroupIndex + 1;
              } else if (_item.groupIndex! >= sourceGroupIndex) {
                _item.groupIndex = _item.groupIndex! - 1;
              }
            });
          } else {
            activeFields.forEach((_item) => {
              if (_item.id === movedItem) {
                _item.group = targetGroup - 1;
                _item.groupIndex = targetGroupIndex;
              } else if (_item.group! > sourceGroup) {
                _item.group = _item.group! - 1;
              }
            });
          }
        } else {
          // to new one

          const realHoverId =
            hoverID === "topBox"
              ? 0
              : parseInt(hoverID.replace("after_", "")) + 1;
          const switchedSource = sourceGroup + 1;
          const sourceGroupIndex =
            sGroup.find((_item) => _item.id === movedItem)?.groupIndex || 0;

          if (realHoverId <= switchedSource) {
            activeFields.forEach((_item) => {
              if (_item.id === movedItem) {
                _item.group = realHoverId;
                _item.groupIndex = 0;
              } else if (_item.group! >= realHoverId) {
                _item.group = _item.group! + 1;
              }
            });
          } else {
            activeFields.forEach((_item) => {
              if (_item.id === movedItem) {
                _item.group = realHoverId;
                _item.groupIndex = 0;
              } else if (_item.group! >= realHoverId) {
                _item.group = _item.group! - 1;
              }
            });
          }
          if (sGroup.length > 1) {
            sGroup.forEach((_item) => {
              if (
                _item.groupIndex! >= sourceGroupIndex &&
                _item.id !== movedItem
              ) {
                _item.groupIndex = _item.groupIndex! - 1;
              }
            });
          } else {
            activeFields.forEach((_item) => {
              if (_item.group! > sourceGroup) {
                _item.group = _item.group! - 1;
              }
            });
          }
        }
      }
    } else {
      //rest
      if (sourceIndex < itemIndex) {
        activeFields.forEach((_item) => {
          if (_item.id === movedItem) {
            _item.itemIndex = itemIndex;
          } else if (
            _item.itemIndex! > sourceIndex &&
            _item.itemIndex! <= itemIndex
          ) {
            _item.itemIndex = _item.itemIndex! - 1;
          }
        });
      } else {
        activeFields.forEach((_item) => {
          if (_item.id === movedItem) {
            _item.itemIndex = hoverID === "topBox" ? 0 : itemIndex + 1;
          } else if (
            _item.itemIndex! < sourceIndex &&
            _item.itemIndex! > itemIndex
          ) {
            _item.itemIndex = _item.itemIndex! + 1;
          }
        });
      }
    }
  }
  return activeFields.sort((a, b) => (a.itemIndex || 0) - (b.itemIndex || 0));
};

//ToDo create unit test for this
export const resetFields = (
  newFields: IFieldsState,
  renderFields: IFieldsState
) => {
  const placeholderGroupID = renderFields.active.find(
    (_item) => _item.id === "placeholder"
  )?.group;

  newFields.active = renderFields.active.filter(
    (_item) => _item.id !== "placeholder"
  );
  if (placeholderGroupID !== -1) {
    let index = 0;
    const group = newFields.active.filter(
      (_item) => _item.group === placeholderGroupID
    );
    group.forEach((_item) => {
      _item.groupIndex = index;
      index++;
    });
  }
  newFields.unactive = renderFields.unactive.filter(
    (_item) => _item.id !== "placeholder"
  );
  return newFields;
};

export const setFormStructure = (
  data: FormDataProps[],
  configs: IOrgFiledsConfigs[],
  name: string
) => {
  const initConfig = getConfig(configs, name);
  const formStrutureData: any[] = [];
  const rowsConfig = setRowsFromFileds(initConfig);
  rowsConfig.forEach((_row) => {
    const rowFields: any = [];
    _row.fields.forEach((_field) => {
      const field = data.find((_item) => _item.name === _field.id);
      if (field) {
        rowFields.push(field);
      }
    });
    const newRow = {
      row: rowFields,
    };
    formStrutureData.push(newRow);
  });
  return formStrutureData;
};
